(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-editorial"] && !Shopify.designMode) return;
  try {
    
  class EditorialMenu extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.toggle = this.querySelector('.header-editorial__menu-toggle');
      this.panel = this.querySelector('.header-editorial__dropdown');
      if (!this.toggle || !this.panel) return;

      // Hover-to-open is only appropriate where a hover state actually exists;
      // touch devices fall back to tapping the trigger.
      this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.closeTimer = null;

      this.toggle.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      clearTimeout(this.closeTimer);
      EditorialMenu.closeAll(this);
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      clearTimeout(this.closeTimer);
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    onClick(event) {
      event.preventDefault();
      this.isOpen ? this.close() : this.open();
    }

    onMouseEnter() {
      if (this.hoverCapable.matches) this.open();
    }

    onMouseLeave() {
      // A short grace period keeps the menu open while the cursor crosses the
      // gap between the trigger and the panel.
      if (this.hoverCapable.matches) {
        this.closeTimer = setTimeout(() => this.close(), 140);
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.toggle.focus();
        return;
      }

      if (event.key === 'ArrowDown' && document.activeElement === this.toggle) {
        event.preventDefault();
        this.open();
        this.panel.querySelector('a')?.focus();
      }
    }

    onFocusOut() {
      // Runs after focus has settled on the newly focused element.
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    static closeAll(except) {
      document.querySelectorAll('editorial-menu').forEach((menu) => {
        if (menu !== except && menu.isOpen) menu.close();
      });
    }
  }

  if (!customElements.get('editorial-menu')) {
    customElements.define('editorial-menu', EditorialMenu);

    document.addEventListener('click', (event) => {
      if (!event.target.closest('editorial-menu')) EditorialMenu.closeAll();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
